import React from "react";
import { useLocation } from "react-router-dom";
import CompanyPage from "../../components/companypage/CompanyPage";

const MasalaBazaar = ({ galary }) => {
  const location = useLocation();
  return (
    <>
      {galary ? (
        <div id="masalabazaar">
          <CompanyPage pathname={location.pathname}></CompanyPage>
        </div>
      ) : (
        <div>This is masalabazaar galary</div>
      )}
    </>
  );
};

export default MasalaBazaar;
